/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { ReactNode } from "react";
import { StepStatusType } from "src/constants/settings.contant";
import { CheckIcon } from "../icons.component";
import { PrefixClassName } from "src/constants/theme.constant";

interface StepProgressProps {
  status: StepStatusType;
  icon: ReactNode;
  showProgress?: boolean;
  label: string,
  stepLevel: number,
  onClick?: (step:number) => void,
};

const StepProgress = ({
  status = StepStatusType.Pending,
  showProgress = true,
  icon,
  label,
  stepLevel,
  onClick,
}: StepProgressProps) => {
  return (
    <>
      <div className={`${PrefixClassName}-step-progress ${status === StepStatusType.InProgress ?
          `${PrefixClassName}-step-progress--inprogress`: status === StepStatusType.Completed ? 
          `${PrefixClassName}-step-progress--completed`: ''}`}>
        <button type="button" onClick={()=>onClick && onClick(stepLevel)} className={`${PrefixClassName}-step-progress__icon action-level-${stepLevel}`}>
          {status === StepStatusType.Completed ? (
            <><CheckIcon /></>
          ) : (
            <>{icon}</>
          )}
        </button>
        <div className={`${PrefixClassName}-step-progress__label`}>
          {label}
        </div>
        {showProgress && (
          <div className={`${PrefixClassName}-step-progress__bar`}>
            <hr className={`${PrefixClassName}-step-progress__bar__line`} />
          </div>
        )}
      </div>
    </>
  );
};

export default StepProgress;
